import moment from "moment"
import { getNewFormattedDate } from "./funciones"

export const estructura_producto = {
    tipPro: "",
    artCod: "",
    codRed: "",
    descrp: "",
    quantity: "1",
    textAdic: "",
    activoID: "",
    codActivoID:"",
    productID: "",
    comUserID:"",
    userName:"",
    usr_id: (Math.random() * 100).toString()
}
export const createEstructuraProducto = () => ({
    tipPro: "",
    artCod: "",
    codRed: "",
    descrp: "",
    quantity: "1",
    textAdic: "",
    activoID: "",
    codActivoID:"",
    productID: "",
    comUserID:"",
    userName:"",
    usr_id: (Math.random() * 100).toString()
})

export const createEstructuraABMProducto = () => ({
    tipPro: "",
    artCod: "",
    codRed: "",
    descrp: "",
    precio:0,
    enableCons:false,
    origen:'M'
})
export const createEstructuraABMCategoriaRRHH = () => ({
    codigo:"",
    descrp:"",
    basico: 0,
    basicoHora: 0,
    adicional: 0,
    origen:'M'
})
export const createEstructuraABMLegajo = () => ({
    codigo:"",
    nombre:"",
    catego:{value:'',label:''},
    categoriaID:'',
    origen:'M'
})
export const createEstructuraLegajo = () => ({
    codigo:"",
    nombre:"",
    catego:{value:'',label:''},
    categoriaID:''
})
export const createEstructuraABMProveedor = () => ({
    nroCta:"",
    nombre:"",
    origen:'M'
})
export const createEstructuraProveedor = () => ({
    proveedor:{label:'',value:'',id:''},
    textAdic:'',
    importe:0
})

export const estructuraProcedimiento = {
    value:'', label:'', lecturaCompletadoInicial: null
}
export const createEstructuraProcedimiento = () => ({
    value:'', label:'', lecturaCompletadoInicial: null
})
export const estructuraNivel1 = {
    value:'',label:'',codNivel1:'',id:'',name:'',descrp:''
}  
export const createEstructuraNivel1 = () => ({
    value:'',label:'',codNivel1:'',id:'',name:'',descrp:''
})

export const estructuraLogsFServ = {
    fecha:'',evento:{value:'',label:''},textAdic:''
}
export const createEstructuraLogsFServ = () => ({
    rowKey: crypto.randomUUID(), fecha: getNewFormattedDate(), evento:{value:'',label:''}, textAdic:''
});

export const estructuraLectura = {
    fecha:getNewFormattedDate() ,user:'',uniMed:'',valor:'',cargaMasiva:{value:null,label:"Sin carga masiva"}
}
export const createEstructuraLectura = () => ({
    fecha: getNewFormattedDate() ,user:'',uniMed:'',valor:'',cargaMasiva:{value:null,label:"Sin carga masiva"}
});

export const estructuraDocumento = {
    documento:{value:'',label:''},fecha:new Date().toISOString().substring(0,10),textAdic:'',alertaAnticipo:0
}
export const createEstructuraDocumento = () => ({
    documento:{value:'',label:''},fecha: getNewFormattedDate(),textAdic:'',alertaAnticipo:0
});

export const createEstructuraFichaTecnica = () => ({
    atributo:{value:'', label:''}, valor:'', textAdic:''
})

export const estructuraProcedimientoProgramado = {
    codActivo:'', codProc:{...estructuraProcedimiento,_id:''}, procedimientoID:'', uniMed:'', valorLecturaUltima:0, valorLecturaAlerta:0, valorLecturaVencimiento:0, valorLecturaCompletado:0, fechaVencimiento:'', fechaCompletado:'',CodForOT:'',NroForOT:'', tipoAlerta:{label:'',value:''},
    state:{label:'',value:''}
}
export const estructuraTipoActivo = {
    codTypeActivo: '',
    descrp: '',
    id: '',
    label: '',
    name: '',
    nameTypeActivo: '',
    value: ''
}
export const estructuraLogsUbicacion = {
    nivel1:{label:'',value:'',id:''},
    nivel2:{label:'',value:'',id:''},
    nivel3:{label:'',value:'',id:''},
    textAdic:'',
    user:{label:'', value:'', comUserID:'', userName:''}
}
export const createEstructuraLogsUbicaciones = () => ({
    nivel1:{label:'',value:'',id:''},
    nivel2:{label:'',value:'',id:''},
    nivel3:{label:'',value:'',id:''},
    nivel4:{label:'',value:'',id:''},
    nivel5:{label:'',value:'',id:''},
    textAdic:'',
    user:{label:'', value:'', comUserID:'', userName:''},
    fecha: getNewFormattedDate()
})
export const estructuraActivo = {
    _id:'', name:'', codActivo:'', descrp:'', fecIng: new Date().toISOString().substring(0,10),tipPro:'', artCod:'', priority:'', fijo: false, habilitadoProduccion: false, fServ:false, actStatus: '', DEFAULTUNIMED: {label:'', value:''}, ajusteLecturas: 0, DEFAULTUNIMED2: {label:'', value:''}, ajusteLecturas2: 0,
    nivel1:{...estructuraNivel1}, 
    nivel2:{...estructuraNivel1}, 
    nivel3:{...estructuraNivel1}, 
    nivel4:{...estructuraNivel1}, 
    nivel5:{...estructuraNivel1}, 
    productos: [{...estructura_producto}], 
    procedimientos:[{...estructuraProcedimiento}], 
    logsFServ:[{...estructuraLogsFServ}],
    lecturas:[{...estructuraLectura}],
    procsProgramados:[{...estructuraProcedimientoProgramado}],
    documentos:[{...estructuraDocumento}],
    logsUbicaciones:[{...estructuraLogsUbicacion}]
}

export const createEstructuraActivo = () => ({
    _id:'', name:'', codActivo:'', descrp:'', fecIng: new Date().toISOString().substring(0,10),tipPro:'', artCod:'', priority:'0', criticidad:'0', fijo: false, habilitadoProduccion: false, fServ:false, actStatus: '', DEFAULTUNIMED: {label:'', value:''}, ajusteLecturas: 0, DEFAULTUNIMED2: {label:'', value:''}, ajusteLecturas2: 0,
    nivel1:createEstructuraNivel1(), 
    nivel2:createEstructuraNivel1(), 
    nivel3:createEstructuraNivel1(), 
    nivel4:createEstructuraNivel1(), 
    nivel5:createEstructuraNivel1(), 
    productos: [{...estructura_producto}], 
    procedimientos:[{...estructuraProcedimiento}], 
    logsFServ:[{...createEstructuraLogsFServ()}],
    lecturas:[{...createEstructuraLectura()}],
    procsProgramados:[{...estructuraProcedimientoProgramado}],
    documentos:[{...createEstructuraDocumento()}],
    logsUbicaciones:[{...createEstructuraLogsUbicaciones()}],
    fichaTecnica:[{...createEstructuraFichaTecnica()}],
    reservable: false,
    tipoReserva: null
})

export const createEstructuraChecklistsByProcedimiento = () => ({
    checklist:{value:'', label:''}, textAdic:''
})


/*Estructuras Procedimientos*/
export const estructuraTarea = {
    value:"",label:"",taskDescrp:"",noDisparaProc:false
}

export const estructuraPeligro = {
    value:"",label:"",textAdic:""
}

export const estructuraEpp = {
    value:"",label:"",textAdic:""
}

export const estructuraHerramienta = {
    value:"",label:"",textAdic:""
}

export const estructuraEqpg = {
    value:"",label:"",textAdic:""
}

export const estructuraImputaciónRRHH = {
    legajo:{label:'',value:'',id:'',catego:0},
    textAdic:'',
    cantHoras:0
}


export const estructuraOrdenTrabajo = {
    title: "",
    observ: "",
    deliveryDate: new Date(),
    priority: 0,
    duracion: 0,
    dateOfIssue: new Date(),
    productos:[{...estructura_producto}],
    tareas:[{...estructuraTarea}],
    peligros:[],
    epps:[{...estructuraEpp}],
    herramientas:[{...estructuraHerramienta}],
    eqpgs:[{...estructuraEqpg}],
    imputaciones:[{...estructuraImputaciónRRHH}],
    proveedores:[{...createEstructuraProveedor()}],
    observ:'',
    activo:{id:'',label:'',value:''},
    enviado: false,
    superposicionTareas: false,
    bloquearEquipos: false,
    bloquearEquiposCual: ''
}

export const createEstructuraConsumo = () => ({
    title: "",
    observ: "",
    priority: 0,
    duracion: 0,
    dateOfIssue: new Date(),
    deliveryDate: new Date(),
    fecInicio: moment().startOf('day'),
    fecFin: moment().startOf('day'),
    cantDias: 0,
    productos:[{...createEstructuraProducto()}],
    observ:'',
    activo:{id:'',label:'',value:''},
    enviado: false
})

export const createEstructuraOPD = () => ({
    title: "",
    fecMov: new Date(),
    deliveryDate: null,
    notePubl: "",
    state: "PENDIENTE",
    priority: 0,
    quantity: 1,
    productos: [{...createEstructuraProducto()}],
    templatesProduccion: [{ value: '', label: '', codTemplate: '', name: '', unidades: '', metros: '', kilos: '' }],
    imputaciones: [{...estructuraImputaciónRRHH}],
    tareas: [{...estructuraTarea}],
    importeTotalRRHH: 0,
    direccion: '',
    lat: null,
    lng: null
})

export const estructuraCategoriaAsociada = {
    categoria:{label:'',value:'',id:''},
    textAdic:'',
    cantHoras:0
}

export const estructuraProcedimientoForm = {
    codProc:'', name:'', descrp:'', uniMed:'', tipProc:{value:'', label:''}, tipAct:'', valInicio:0, tareas:[{...estructuraTarea}], productos:[{...estructura_producto}], categorias:[{...estructuraCategoriaAsociada}], checklists:[createEstructuraChecklistsByProcedimiento()],incluidoEn: [],
    supervisorVisible: false, disableActivo: false, enableActivo: false,
    programarAl: {value:'ULTIMOCREADO', label:'Cumplirse el valor alerta desde el último completado'}, cadaMeses: 1
}

export const createEstructuraProcedimientoForm = () => ({
    codProc:'', name:'', descrp:'',
    uniMed:'', uniMed2:'',
    tipProc:{value:'', label:''}, tipAct:'', valInicio:0, tareas:[{...estructuraTarea}], productos:[{...estructura_producto}], categorias:[{...estructuraCategoriaAsociada}], checklists:[createEstructuraChecklistsByProcedimiento()],incluidoEn: [],
    supervisorVisible: false, disableActivo: false, enableActivo: false, notAllowEnableActivo:false, noContabilizaFSERV: false,
    programarAl: {value:'ULTIMOCREADO', label:'Cumplirse el valor alerta desde el último completado'}, cadaMeses: 1,
})

export const estructuraChecklist = {
    codigo:'', name:'', tipAct:'', visualizarCrono:false, solicitaCantCombustible: false, solicitarCantCombustibleGeneral: false, solicitarCantCombustiblePreciso: false, solicitarDuracionCarga: false, solicitarSector: false, solicitarImputacionesRRHH: false, solicitarLecturasActivo: false, uniMed: null, uniMedExtra: null, disponibleParaMecanicos: false, solicitarInfoMomento: null, uniqueRead: false, controles:[{...estructuraTarea}]
}




/*----------Estructuras para Opciones ya definidad----------*/
export const cargaMasivaOpciones = [
    {value:"INCREMENTO",label:"REPLICA INCREMENTO ACTIVOS MISMO ÁREA"}, {value:"VALOR",label:"REPLICA VALOR ACTIVOS MISMO ÁREA"}, {value:null,label:"Sin carga masiva"}
];
export const unidadesMedidasOpciones = [
    {value:"HS",label:"Horas"}, {value:"HSsec",label:"Horas Secundarias"}, {value:"KM",label:"Kilómetros"}
];
export const estadosProcedimientosOpciones = [
    {value:"PEND",label:"Pendiente"}, {value:"PROG",label:"En Progreso"}, {value:"COMPL",label:"Completado"}
];
export const tipoAlertaProcedimientosOpciones = [
    {value:"VENC",label:"Vencido"}, {value:"PorVENC",label:"Por Vencer"}
];
export const opcionesTipoProcedimiento = [
    {value:"CORRECTIVO",label:"Correctivo"}, {value:"PREVENTIVO",label:"Preventivo"}, {value:"PREDICTIVO",label:"Predictivo"}, {value:'PREVENTIVONOPeriod',label:'Preventivo No Periódico'}, {value:'MEJORA',label:'Mejora'}
];
export const opcionesProgramarAl = [
    {value:'ULTIMOCREADO',label:'Cumplirse el valor alerta desde el último completado'}, {value:'INICIOMES',label:'Inicio del mes'}, {value:'FINMES',label:'Fin del mes'}
];
export const opcionesActStatus = [
    {label:'Disponible', value:'DISPO'}, {label:'Fuera de Servicio', value: 'FSERV'}
]
export const opcionesPedirLecturaActivo = [
    {value:'NUNCA', label:'Nunca'}, {value:'SIEMPRE', label:'Siempre'}, {value:'DEFAULTUNIMED', label:'Si el procedimiento posee la misma unidad de lectura que "Lecturas por Defecto en"'}
]
export const unidadesMedidasOpcionesFiltro = [
    {value:"HS",label:"Horas"},{value:"HSsec",label:"Horas Secundarias"},{value:"KM",label:"Kilómetros"}
];
